module.exports = __webpack_public_path__ + "img/central_african_republic.c13d87d.webp";